import React from 'react'
import api from 'core/api/contentstack'
import { layoutData } from 'core/layout'
import Render from 'core/layout/Render'

const Home = (props: any) => {
  return <Render
    pageComponents={props.result?.shared_components?.components}
    contentTypeUid="page"
    translations={props.translations}
    entryUid={props.result?.uid}
    locale={props.result?.locale} />
}

export default Home

export async function getStaticProps(context: any) {
  let result: any, layout: any
  try {
    ;[result, layout] = await Promise.all([
      api.getEntryByUrl("page", "/", context.locale, [
        "shared_components.components.featured_products.items",
        "shared_components.components.featured_products.items.color",
        "shared_components.components.featured_products.items.filters",
        "shared_components.components.featured_recipes.items",
        "shared_components.components.featured_recipes.items.filters",
        "shared_components.components.featured_recipes.items.product.color",
        "shared_components.components.featured_recipes.items.product.filters",
        "shared_components.components.mixed_content_banner.color",
        "shared_components.components.product_banner.product.color",
        "shared_components.components.product_banner.product",
        "shared_components.components.icon_sections.background_color",
        "shared_components.components.logo_showcase.background_color",
        "shared_components.components.categories.items.background_color"
      ]),
      layoutData(api, context.locale),
    ])
  } catch (err) {
    console.error('getStaticProps (home): CMS fetch failed', err)
    return { notFound: true, revalidate: 60 }
  }

  // revalidate: 60 — retry aggressively while CMS entry is missing or unavailable
  if (!result) return { notFound: true, revalidate: 60 }

  const heroImage = result.shared_components?.components
    ?.find((c: any) => c.hero_carousel)
    ?.hero_carousel?.carousel_items?.[0]?.image?.url

  return {
    props: { layout: true, ...layout, result, seo: result.seo, lcp_image: heroImage || null },
    revalidate: 43200,
  }
}